// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__29iEl","list":"PatternAutocomplete_list__1PShQ"};